import { useEffect } from 'react';
import PubSub from 'pubsub-js';

import useSignOut from '../hooks/amplifySession/useSignOut';

// TODO: find a better way to handle this
export function SignOutSubscriber() {
  const { onSignOutClick } = useSignOut();
  useEffect(() => {
    if (import.meta.env.NX_PUB_SUB_TOPIC_SIGN_OUT) {
      const subscription = PubSub.subscribe(
        import.meta.env.NX_PUB_SUB_TOPIC_SIGN_OUT,
        () => onSignOutClick()
      );

      return () => {
        PubSub.unsubscribe(subscription);
      };
    }
    return undefined;
  }, [onSignOutClick]);

  return null;
}

export default SignOutSubscriber;
